import { useEffect, useState, useCallback } from "react";
import { postsService } from "../services/postsService";

export default function usePosts(
  search,
  category,
  status
) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const loadPosts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response =
        await postsService.getPosts({
          search,
          category,
          status,
        });

      setPosts(response.results || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [
    search,
    category,
    status,
  ]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  const deletePost = async (id) => {

    if (!window.confirm("Delete this post?")) {
        return;
    }

    try {

        setDeletingId(id);

        await postsService.deletePost(id);

        setPosts((prev) =>
            prev.filter((post) => post.id !== id)
        );

    } catch (error) {

        console.error(error);

        alert("Failed to delete post.");

    } finally {

        setDeletingId(null);

    }

};

  return {
    posts,
    loading,
    error,
    deletingId,
    deletePost,
    reload: loadPosts,
  };
}